import { H3Alternate } from '@thesisedu/web/dist'
import { graphql, useStaticQuery } from 'gatsby'
import { groupBy } from 'lodash'
import moment from 'moment'
import React from 'react'

import { Content } from './Article'
import { PRODUCT_NAME } from './constants'
import { BorderH2 } from './styled'

const query = graphql`
  query changelog {
    content: allSanityChange(sort: { fields: [date, name], order: [DESC, ASC] }) {
      edges {
        node {
          id
          name
          date
          products
          _rawContent(resolveReferences: { maxDepth: 10 })
        }
      }
    }
  }
`

export function Changelog() {
  const result = useStaticQuery(query)
  const updates = result.content.edges
    .filter(edge => edge.node.products.includes(PRODUCT_NAME))
    .map(edge => edge.node)
  const groupedByYear = groupBy(updates, update => {
    return moment(update.date).format('YYYY')
  })
  const sortedYears = Object.keys(groupedByYear).sort().reverse()
  return (
    <>
      {sortedYears.map(sortedYear => (
        <React.Fragment key={sortedYear}>
          <BorderH2>{sortedYear}</BorderH2>
          {groupedByYear[sortedYear].map(update => (
            <React.Fragment key={update.id}>
              <H3Alternate>{update.name}</H3Alternate>
              <Content content={update._rawContent} />
            </React.Fragment>
          ))}
        </React.Fragment>
      ))}
    </>
  )
}
